import React from "react";
import { Editing } from "./Editing";
import { Documenticon } from "./Documenticon";
import { Associatedapplicants } from "./Associatedapplicants";
import { Portal } from "./portal";
import { Notesicon } from "./notesicon";
import { Jobportal } from "./jobportal";
import { AuditInfoInactive } from "./auditInfo-Inactive";
import { Userinactive } from "./userinactive";
import { GroupUsersInactive } from "./groupUsers-Inactive";
import { Settings } from "./settings";
import { Jobboardportal_black } from "./jobboardportal_black";
import { MailInactive } from "./mail-Inactive";
import { Segment } from "./Segment";
import { HiringManagers } from "./HiringManagers";
import { ProjectJobs } from "./ProjectJobs";
import { Clients } from "./Clients";

export const IconsComponent = (iconType, storedTheme) => {
  const iconsList = {
    editingIcon: <Editing primaryFontColor={storedTheme?.secondaryColor} />,
    documentIcon: (
      <Documenticon primaryFontColor={storedTheme?.secondaryColor} />
    ),
    associatedApplicantsIcon: (
      <Associatedapplicants primaryFontColor={storedTheme?.secondaryColor} />
    ),
    portalIcon: <Portal primaryFontColor={storedTheme?.secondaryColor} />,
    notesIcon: <Notesicon primaryFontColor={storedTheme?.secondaryColor} />,
    screenQuestionsIcon: (
      <Jobportal primaryFontColor={storedTheme?.secondaryColor} />
    ),
    auditIcon: (
      <AuditInfoInactive primaryFontColor={storedTheme?.secondaryColor} />
    ),
    customerIcon: (
      <Userinactive primaryFontColor={storedTheme?.secondaryColor} />
    ),
    groupIcon: (
      <GroupUsersInactive primaryFontColor={storedTheme?.secondaryColor} />
    ),
    CustomIcon: <Settings primaryFontColor={storedTheme?.secondaryColor} />,
    jobportalIcon: (
      <Jobboardportal_black primaryFontColor={storedTheme?.secondaryColor} />
    ),
    mailIcon: <MailInactive primaryFontColor={storedTheme?.secondaryColor} />,
    segmentsIcon: <Segment primaryFontColor={storedTheme?.secondaryColor} />,
    HiringManagers: (
      <HiringManagers primaryFontColor={storedTheme?.secondaryColor} />
    ),
    ProjectJobs: <ProjectJobs primaryFontColor={storedTheme?.secondaryColor} />,
    Clients: <Clients primaryFontColor={storedTheme?.secondaryColor} />,
  };
  return iconsList[iconType] || "";
};
